import type { Component } from "vue";
import type { DecorationIcon } from "#ui/decoration/types";
import CartBackText from "./cartBackText/CartBackText.vue";
import CartCommentIcon from "./cartCommentIcon/CartCommentIcon.vue";
import CartCommentText from "./cartCommentText/CartCommentText.vue";
import CartIcon from "./cartIcon/CartIcon.vue";
import CartLoyaltyText from "./cartLoyaltyText/CartLoyaltyText.vue";
import CartPayText from "./cartPayText/CartPayText.vue";
import CartPayTotal from "./cartPayTotal/CartPayTotal.vue";

export interface CartIconControl {
	icon: DecorationIcon | null;
	fallback: string;
}

export interface CartBackControl extends CartIconControl {
	label: string | null;
}

export interface CartCommentControl extends CartIconControl {
	label: string;
	disabled: boolean;
	toggle: () => void;
}

export interface CartLoyaltyControl extends CartIconControl {
	label: string;
	sticker: string | null;
	stickerOffset: number;
}

export interface CartPayControl extends CartIconControl {
	label: string;
	total: number;
	symbol: string | null;
	disabled: boolean;
	action: () => void;
}

export const CART_BACK_DEFAULT = "text";
export const CART_COMMENT_DEFAULT = "text";
export const CART_LOYALTY_DEFAULT = "text";
export const CART_PAY_DEFAULT = "text";

export const cartBackVariants: Record<string, Component> = {
	text: CartBackText,
	icon: CartIcon,
};

export const cartCommentVariants: Record<string, Component> = {
	text: CartCommentText,
	icon: CartCommentIcon,
};

export const cartLoyaltyVariants: Record<string, Component> = {
	text: CartLoyaltyText,
	icon: CartIcon,
};

export const cartPayVariants: Record<string, Component> = {
	text: CartPayText,
	total: CartPayTotal,
};
